module.exports = __webpack_public_path__ + "c004d13ee0caef5b298fda1911520537.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/experience-yellow.svg
// module id = 2888
// module chunks = 24